import MRitualPreview from './MRitualPreview.vue';

export { MRitualPreview };
export default MRitualPreview;
